import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import UIIcon from "common/blocks/UIIcon";
import specDataHelper from "features/vehicleDetails/helpers/specDataHelper";
import { featuresSpecsModal } from "features/vehicleDetails/modals";
import { FeaturesSpecsSelectedTab } from "features/vehicleDetails/modals/FeaturesSpecs";
import { EventNames, usePub } from "hooks/usePublishSubscribe";
import { VehicleSpecsFeaturesPacks } from "resolvers/data/pdp/pdpVehicleSpecsResolver";
import { toTitleCase } from "utils/language-helpers";

import styles from "./CarSpecs.module.scss";

const cx = classNames.bind(styles);

export type OrderedSpec = { key: string; label: string; postfix?: string };

export type CarSpecsProps = {
    title: string;
    seeAllButtonText: string;
    noSpecsMessage: string;
    maxSummarySpecs?: number;
    specsOrder: OrderedSpec[];
    specs: VehicleSpecsFeaturesPacks;
};

const CarSpecs = ({
    specs,
    noSpecsMessage,
    seeAllButtonText,
    title,
    maxSummarySpecs = 8,
    specsOrder,
    handleOpenFeaturesSpecsModal,
}: CarSpecsProps & {
    handleOpenFeaturesSpecsModal: (
        selectedRow?: string,
        selectedTab?: FeaturesSpecsSelectedTab
    ) => any;
}) => {
    const publish = usePub();

    const createRow = (orderedSpec: OrderedSpec, value: string) => (
        <div key={orderedSpec.key} className={cx("row")}>
            <span className={cx("key")}>{orderedSpec.label}</span>
            <span className={cx("value")}>
                {toTitleCase(value)}
                {orderedSpec?.postfix ?? ""}
            </span>
        </div>
    );

    const { orderedSpecs } = specDataHelper({
        maxSummarySpecs,
        callbackFn: (spec, value) => createRow(spec, value),
        specs,
        specsOrder,
    });

    const featuresSpecsData = handleOpenFeaturesSpecsModal("Summary", "specs");
    return (
        <>
            <div className={cx("titleRow")}>
                <h4 className={cx("title")}>{title}</h4>
                {seeAllButtonText &&
                    !!orderedSpecs?.length &&
                    specs.generalspecs.length > maxSummarySpecs && (
                        <Button
                            onClick={() =>
                                publish(EventNames.OpenSidebar, {
                                    sidebar: featuresSpecsModal,
                                    params: featuresSpecsData,
                                })
                            }
                            theme="textLink"
                            ariaLabel={seeAllButtonText}
                        >
                            {seeAllButtonText}
                        </Button>
                    )}
            </div>
            <div id="car-specs" className={cx("car-specs")}>
                {!!orderedSpecs?.length ? (
                    orderedSpecs
                ) : (
                    <div className={cx("noSpecsRow")}>
                        <UIIcon icon="Cross" />
                        <p className={cx("noSpecs")}>{noSpecsMessage}</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default CarSpecs;
